import { RefDataState } from "app/pages/DiscountEditor/modules/RefData/state";
import { Action, ActionType } from "app/pages/DiscountEditor/actionTypes";

const startingState : RefDataState = {
    allCurrencies: [], 
    allBookingSystems: []
}

export function reducer(state: RefDataState|undefined, action: Action) : RefDataState {
    if (!state) {
        return startingState;
    }

    switch(action.type) {
        case ActionType.PageLoaded:
            return {
                allCurrencies: action.data.currencies, 
                allBookingSystems: action.data.bookingSystems
            }
        default: 
            return state; 
    }
}